
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9.5","height":"5.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.28.22a.75.75 0 01.073.98l-.073.08-4 4a.75.75 0 01-.977.073L4.22 5.28l-4-4A.75.75 0 011.2.147l.08.073 3.47 3.469L8.22.22A.75.75 0 019.2.147z","fill":"#fc6b36","data-name":"Icons / chevron - right"}})])
          )
        }
      }
    